const carouselBreakpoints = {
  0: { slidesPerView: 1 },
  768: { slidesPerView: 2 },
  1200: { slidesPerView: 3 }
};

export default carouselBreakpoints;
